@if (this.data.type == 'number' || this.data.type == 'email' || this.data.type
== 'both') { @if(!isVerified ){
<div class="popup-container d-flex flex-column">
  <div class="header-section">
    <!-- @if(data.type == 'number'){ -->
    <span class="header-text">Verify details to save changes</span>
    <!-- }@else if(data.type == 'email'){
      <span class="header-text">Otp sent to: {{data.email}}</span>
    } -->
    <div class="img-container" (click)="onClose('dpVerify')">
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>

  <span class="content-text"
    >We've sent an authentication code on DP updated phone number. Please enter
    and verify to proceed.</span
  >

  <div class="input-field">
    <span class="input-text">Otp sent to {{ phoneNo }}</span>
    <input
      type="text"
      id="otp"
      placeholder="Enter the otp"
      class="dp-input-control searchInput"
      [(ngModel)]="mobileOtp"
      name="otp"
      #otpModel="ngModel"
      required
      maxLength="6"
      (keydown)="restrictOtpInput($event)"
    />
    <div style="color: var(--brand-destructive)">
      @if(otpModel.dirty && otpModel.errors?.['pattern']){
      <p>OTP must be in number!</p>
      }@else if(otpModel.touched && otpModel.errors?.['required']){
      <p>OTP is required.</p>
      }
    </div>
    @if(otpTimer <= 0 ){
    <span class="resend-text" (click)="resendOtp('otp')">Resend code</span>
    }@else if(otpTimer>0){
    <span class="resend-countdown-text"> Resend in {{ otpTimer }}s </span>
    }
  </div>
  <button
    class="saveChanges-btn dp-primary-btn"
    [disabled]="otpModel.invalid"
    (click)="verifyOtp('Otp')"
  >
    <span class="me-2">Verify Phone</span>
  </button>
</div>
}@else{
<div class="popup-container d-flex flex-column">
  <div class="header-section">
    <span class="header-text">Verify details to save changes</span>
    <div class="img-container" (click)="onClose('newVerify')">
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>
  @if(data.type == 'both'){
  <span class="content-text">
    Please verify your new phone '{{ data.currentNo }}'and new email '{{
      data.currentEmail
    }}'</span
  >
  }@else{
  <span class="content-text">{{
    data.type == "number"
      ? "Please verify your new phone " + data.currentNo
      : "Please verify your new email " + data.currentEmail
  }}</span>

  }
  <div class="input-field">
    @if(data.currentNo){ @if(!isMobileOtpValid){
    <span class="input-text">OTP sent on phone</span>
    <div class="inp-btn">
      <input
        type="text"
        id="otp"
        placeholder="Enter the otp"
        class="dp-input-control searchInput"
        [(ngModel)]="finalOtp"
        name="finalOtp"
        #Otp="ngModel"
        required
        maxLength="6"
        (keydown)="restrictOtpInput($event)"
      />
      <button
        class="saveChanges-btn dp-secondary-btn"
        [disabled]="Otp.invalid"
        (click)="verifyOtp('mobileOtp')"
      >
        <span>Verify</span>
      </button>
    </div>
    <div style="color: var(--brand-destructive)">
      @if(Otp.dirty && Otp.errors?.['pattern']){
      <p>OTP must be in number!</p>
      }@else if(Otp.touched && Otp.errors?.['required']){
      <p>OTP is required.</p>
      }
    </div>
    @if(otpTimer <= 0){
    <span class="resend-text" (click)="resendOtp('mobileOtp')">
      Resend code
    </span>
    }@else if(otpTimer>0){
    <span class="resend-countdown-text"> Resend in {{ otpTimer }}s </span>
    } }@else{
    <div class="verified">
      <img src="../../../../assets/images/shield-check-line.png" alt="" />
      <span class="verified-text">{{ data.currentNo }} is verfied now</span>
    </div>
    } } @if(data.currentEmail){ @if(!isEmailOtpValid){
    <span class="input-text">OTP sent on email</span>
    <div class="inp-btn">
      <input
        type="text"
        id="otp"
        placeholder="Enter the otp"
        class="dp-input-control searchInput"
        [(ngModel)]="emailOtp"
        name="finalOtp"
        #Otp="ngModel"
        required
        maxLength="6"
        (keydown)="restrictOtpInput($event)"
      />
      <button
        class="saveChanges-btn dp-secondary-btn"
        [disabled]="Otp.invalid"
        (click)="verifyOtp('emailOtp')"
      >
        <span>Verify</span>
      </button>
    </div>
    <div style="color: var(--brand-destructive)">
      @if(Otp.dirty && Otp.errors?.['maxlength']){
      <p>OTP must be in 6 digits!</p>
      }@else if(Otp.touched && Otp.errors?.['required']){
      <p>Email is required.</p>
      }
    </div>
    @if(otpTimer <= 0){
    <span class="resend-text" (click)="resendOtp('emailOtp')">
      Resend code
    </span>
    }@else if(otpTimer>0){
    <span class="resend-countdown-text"> Resend in {{ otpTimer }}s </span>
    } }@else{
    <div class="verified">
      <img src="../../../../assets/images/shield-check-line.png" alt="" />
      <span class="verified-text">{{ data.currentEmail }} is verfied now</span>
    </div>
    } }
  </div>
  <button
    class="saveChanges-btn"
    [ngClass]="[isOtpValid ? 'dp-primary-btn' : 'dp-primary-btn-disabled']"
    [disabled]="!isOtpValid"
    (click)="updateProfile('update')"
  >
    <span>Update profile changes</span>
  </button>
</div>

} }
